module.exports = __webpack_public_path__ + "static/media/settings-kuara.69ce1ed7.svg";